import { ValePagLogo } from './ValePagLogo';
import { BRAND_HTML_META } from './meta';
import type { BrandConfig } from './types';

// Brand white-label ValePag. Paleta extraida do projeto de referencia
// (~/Documents/Claude/Devs/Propostas/valepag-demo/index.html e login.html,
// escalas Tailwind inline "vp-navy"/"vp-green"). A escala navy do deck tem
// 11 degraus (50..950); a nossa (mesma forma de brand-navy-* do JUST) tem
// 10 (50..900) - mapeada com deslocamento de 1 posicao pra que o degrau mais
// escuro (900, usado em --color-sidebar-bg) bata com o navy-950 real do
// deck (#0a1720, o navy mais profundo usado no sidebar/hero de login la).
export const valepagBrand: BrandConfig = {
  id: 'valepag',
  ...BRAND_HTML_META.valepag,
  // TODO: confirmar razao social exata da ValePag antes de ir pra producao.
  legalFooter: '(c) 2026 ValePag - Plataforma de Gestão de Frota.',
  palette: {
    navy: {
      '50': '#dae4e8',
      '100': '#b5c9d1',
      '200': '#8aa7b3',
      '300': '#5d8491',
      '400': '#3f6775',
      '500': '#2f505d',
      '600': '#27414b',
      '700': '#1a2d36',
      '800': '#0f1e28',
      '900': '#0a1720',
    },
    accent: {
      '50': '#ecfdf3',
      '100': '#d1fadf',
      '200': '#a6f4c5',
      '300': '#6ce9a6',
      '400': '#32d583',
      '500': '#19b24b',
      '600': '#12a347',
      '700': '#087c3b',
      '800': '#065f32',
      '900': '#054f2b',
    },
  },
  Logo: ValePagLogo,
  pdf: {
    navyRgb: [10, 23, 32],
    accentRgb: [25, 178, 75],
  },
};
